import { useState } from 'react';
import { useDrag as dndUseDrag, useDrop as dndUseDrop } from 'react-dnd';

export const DND_TYPE = 'DND_TYPE_MATERIAL';

export const useDrag = (props) =>
  dndUseDrag({
    item: {
      type: DND_TYPE,
      ...props,
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

export const useDrop = (destProps, ref) => {
  const [dropType, setDropType] = useState(null);

  const getDropType = (monitor) => {
    const position = monitor.getClientOffset();
    if (!ref.current || !position) {
      return null;
    }

    if (destProps.isFolder && destProps.expanded) {
      return 'before';
    }

    const bounds = ref.current.getBoundingClientRect();
    const middleY = (bounds.bottom - bounds.top) / 2;
    const relativeY = position.y - bounds.top;
    return relativeY < middleY ? 'before' : 'after';
  };

  const updateDropType = (monitor) => {
    const isDraggingOver = monitor.isOver() && monitor.canDrop();
    const newDropType = getDropType(monitor);
    setDropType(isDraggingOver ? newDropType : null);
  };

  const [, drop] = dndUseDrop({
    accept: DND_TYPE,
    canDrop: (item) => {
      const differentMaterial = item.materialId !== destProps.materialId;
      const folderIntoFolder = item.isFolder && !!destProps.parent;
      return differentMaterial && !folderIntoFolder;
    },
    drop: (item, monitor) => {
      if (monitor.didDrop() || !ref.current) {
        return;
      }

      item.onReorder({
        sourceId: item.materialId,
        destId: destProps.materialId,
        parentId: destProps.parent,
        dropType: getDropType(monitor),
      });
    },
    hover: (_item, monitor) => {
      updateDropType(monitor);
    },
    collect: (monitor) => {
      updateDropType(monitor);
      return {};
    },
  });

  return [{ dropType }, drop];
};
